<template>
  <div style="background-color:#F7F7F7;padding-bottom:70px;" id="outermost">

    <van-nav-bar
      title="企业基本信息"
      left-text="返回"
      left-arrow
      @click-left="$router.back()"
      id="topbar"
    />
    <div class="topDiv">
      <van-cell-group>
        <van-field label="企业名称" readonly :value="companyInfo.companyName" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="行业" readonly :value="companyInfo.industryName" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="第二行业" :value="companyInfo.industry2Name" input-align="right"/>
      </van-cell-group>
    </div>
    <div class="topDiv">
      <van-cell-group>
        <van-field label="联系人1" readonly :value="companyInfo.contacts1" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="联系电话" readonly :value="companyInfo.phone1" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field v-if="companyInfo.contacts2" label="联系人2" readonly :value="companyInfo.contacts2"
                   input-align="right"/>
        <van-field v-else label="联系人2" readonly value="无" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field v-if="companyInfo.phone2" label="联系电话" readonly :value="companyInfo.phone2" input-align="right"/>
        <van-field v-else label="联系电话" readonly value="无" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field v-if="companyInfo.contacts3" label="联系人3" readonly :value="companyInfo.contacts3"
                   input-align="right"/>
        <van-field v-else label="联系人3" readonly value="无" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field v-if="companyInfo.phone3" label="联系电话" readonly :value="companyInfo.phone3" input-align="right"/>
        <van-field v-else label="联系电话" readonly value="无" input-align="right"/>
      </van-cell-group>
    </div>
    <div class="topDiv">
      <van-cell-group>
        <van-field label="企业地址" type="textarea" readonly :value="companyInfo.companyAddress" input-align="right"/>
      </van-cell-group>
    </div>
    <div class="topDiv" >
      <van-cell-group>
        <van-field label="企业生产状态" label-width="200"  readonly :value="getStatus(companyInfo.status)" input-align="right"/>
      </van-cell-group>
    </div>
    <div class="topDiv">
      <van-cell-group>
        <van-field label="场地基本情况" label-width="200" readonly :value="companyInfo.areaSituation==='1'?'拿地':'租赁'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="是否属于厂中厂（厂主为二房东）" label-width="260"  readonly :value="companyInfo.recursion==='1'?'是':'否'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="应急预案等级" label-width="260"  readonly :value="getLevel(companyInfo.emergencyPlanLevel)" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="是否位于104工业园区" label-width="200" readonly :value="companyInfo.plot==='1'?'是':'否'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="是否为简易监管单位" label-width="200"  readonly :value="companyInfo.basicManage==='1'?'是':'否'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="是否为一般监管单位" label-width="200"  readonly :value="companyInfo.generalManage==='1'?'是':'否'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="是否为重点监管单位" label-width="200"  readonly :value="companyInfo.keyManage==='1'?'是':'否'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="是否为污染源子库单位" label-width="200"  readonly :value="companyInfo.emissionTermbase==='1'?'是':'否'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="废水是否安装在线监测设备" label-width="200"  readonly :value="companyInfo.waterOnlineMonitor==='1'?'是':'否'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="废水是否涉重金属" label-width="200"  readonly :value="companyInfo.waterHeavyMetal==='1'?'是':'否'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="废气是否安装在线监测设备" label-width="200"  readonly :value="companyInfo.gasOnlineMonitor==='1'?'是':'否'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="废气是否涉重金属" label-width="200"  readonly :value="companyInfo.gasHeavyMetal==='1'?'是':'否'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="是否属于强制性清洁生产" label-width="200"  readonly :value="companyInfo.mandatoryCleanProduction==='1'?'是':'否'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="是否有非道路移动机械" label-width="200"  readonly :value="companyInfo.nonRoadMobileMachinery==='1'?'是':'否'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="环保手续" label-width="200"  readonly :value="companyInfo.envRelation==='1'?'有':'无'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="排水许可" label-width="200"  readonly :value="companyInfo.waterPermit==='1'?'有':'无'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="治理设施" label-width="200"  readonly :value="companyInfo.facility==='1'?'有':'无'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="危险废物处理合同及备案" label-width="200"  readonly :value="companyInfo.hazardousProcessAcquired==='1'?'有':'无'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="一般工业固废处理合同及备案" label-width="200"  readonly :value="companyInfo.generalHazardousProcessAcquired==='1'?'有':'无'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="自行监测方案" label-width="200"  readonly :value="companyInfo.selfMonitorPlan==='1'?'有':'无'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="手工监测报告" label-width="200"  readonly :value="companyInfo.waterSoundGasEtc==='1'?'有':'无'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="营业执照" label-width="200"  readonly :value="companyInfo.license==='1'?'有':'无'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="辐射许可证" label-width="200"  readonly :value="companyInfo.radiationPermit==='1'?'有':'无'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="有无清洁生产审核验收报告" label-width="200"  readonly :value="companyInfo.cleanProductionApproval==='1'?'有':'无'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="环境管理制度" label-width="200"  readonly :value="companyInfo.envManageRule==='1'?'有':'无'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="非道路移动机械是否备案上牌" label-width="200"  readonly :value="companyInfo.nonRoadMobileMachineryAcquired==='1'?'是':'否'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="行政处罚" label-width="200"  readonly :value="companyInfo.administrativePenalty==='1'?'有':'无'" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="信用等级" label-width="200"  readonly :value="getCreditLevel(companyInfo.creditLevel)" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="污染源类型" label-width="200"  readonly :value="getPollutionSource(companyInfo.pollutionSource)" input-align="right"/>
      </van-cell-group>
      <van-cell-group>
        <van-field label="固体废物" label-width="60"  readonly :value="getSolidWaste(companyInfo.solidWaste)" input-align="right"/>
      </van-cell-group>
    </div>
    <div style="position: fixed;bottom: 0px;width: 100%;">
      <van-button block color="#1B75F6"  native-type="button" @click="toModifyCompany">修改</van-button>
    </div>
  </div>
</template>

<script>
import $ from '@/fly'

export default {
  name: 'project-companyInfo',
  data() {
    return {
      companyInfo: {}
    }
  },

  methods: {
    getSolidWaste(val){
      var wasteArr = []
      if(val!=null&&val!=''){
        wasteArr = val.split(',')
      }
      var str = ''
      for (let i = 0; i < wasteArr.length; i++) {
        if(wasteArr[i]=='1'){
          if(str==''||str==null){
            str += '一般工业固体废物'
          }else{
            str += '、一般工业固体废物'
          }
        }else if(wasteArr[i]=='2'){
          if(str==''||str==null){
            str += '危险废物'
          }else{
            str += '、危险废物'
          }
        }else if(wasteArr[i]=='3'){
          if(str==''||str==null){
            str += '医疗废物'
          }else{
            str += '、医疗废物'
          }
        }else if(wasteArr[i]=='4'){
          if(str==''||str==null){
            str += '无'
          }else{
            str += '、无'
          }
        }
      }
      return str
    },
    getPollutionSource(val){
      if(val==='1'){
        return '工业源'
      }else if(val==='2'){
        return '集中源'
      }else if(val==='3'){
        return '移动源'
      }else if(val==='4'){
        return '辐射源'
      }else {
        return ''
      }
    },
    yesOrNo(val) {
      if (val === 0) {
        return '否';
      } else if (val === 1) {
        return '是';
      }
    },
    getStatus(val){
      if(val==='1'){
        return '运行'
      }else if(val==='2'){
        return '停产'
      }else if(val==='3'){
        return '迁出'
      }else{
        return '其他'
      }
    },
    getLevel(val){
      if(val==='1'){
        return '重大'
      }else if(val==='2'){
        return '较大'
      }else if(val==='3'){
        return '一般'
      }else{
        return ''
      }
    },
    getCreditLevel(val){
      if(val==='1'){
        return 'A'
      }else if(val==='2'){
        return 'B'
      }else if(val==='3'){
        return 'C'
      }else if(val==='4'){
        return 'D'
      }else if(val==='5'){
        return 'E'
      }else {
        return ''
      }
    },
    toModifyCompany() {
      this.$router.push({name: 'project-modifyCompanyInfo'});
    }
  },
  mounted() {
    $.get('company/getById/' + localStorage.getItem('companyId')).then(res => {
      this.companyInfo = res;
    })
  }
}
</script>

<style lang="less" scoped>
.topDiv {
  margin-top: 20px;
}

.lableTxt {
  height: 80px;
  line-height: 80px;
  font-size: 28px;
  width: 28%;
}

.starTxt {
  height: 80px;
  line-height: 80px;
  font-size: 28px;
}

.starTxt span {
  color: #FF6969;
  font-size: 30px;
  margin-right: 3px;
}

.typeDiv {
  padding: 20px 30px;
  font-size: 28px;
}

.typeRow {
  padding-left: 20px;
  border-left: 6px solid #50C9FF;
}

.typeRow .van-col:nth-child(2) {
  font-size: 0.38rem;
  font-weight: 400;
}

.typeItem {
  box-shadow: #f2f3f5 0px 0px 20px 1px;
}

.type-search {
  background-color: #EBEEF5;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 2vw 4vw;
  border-radius: 50px;
  padding: 0 0 0 4vw;
}

.type-search button {
  border-radius: 0 50px 50px 0;
}

.search-icon {
  margin-left: 5px;
  font-size: 50px;
}

.searchInput {
  margin: 0 1.5vw;
  background-color: #F7F8FA;
  border: 0px;
  font-size: 14px;
  flex: 1;
  background: none;
  padding: 15px;
}

.clear-icon {
  color: #999;
  font-size: 40px;
  margin-right: 15px;
}

.van-cell {
  font-size: 0.37rem;
}

.van-radio {
  color: #666666;
}

</style>
